const userReducer = (state = null, action) => {
    switch (action.type) {
        case "GET_USER":
            return state;

        case "SET_USER":
            return action.user;

        case "SET_USER_NULL":
            return null;  // Set the user to null

        default:
            return state;
    }
};

export default userReducer;
